var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLocate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 21.44l-3.516-3.517a6.02 6.02 0 10-1.06 1.06l3.515 3.517 1.061-1.06zm-8.25-2.69a4.5 4.5 0 110-9 4.5 4.5 0 010 9zM7.5 9h-6v1.5h6V9zM13.5 1.5h-12V3h12V1.5zM13.5 5.25h-12v1.5h12v-1.5z",
    fill: "#45464F"
  })));
}
export default SvgSearchLocate;